import React from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import { UseFirmList } from "../../hooks/Catalogs/useFirm";
import useDataLoader2 from "../../hooks/useDataLoader2";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import PencilEdit from "../../components/Atomos/Icons/PencilEdit";
import { formatDateToString } from "../../utils/functions";
import { defaultPageSize } from "../../utils/const";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import Filters, { IFilterData } from "../../components/Catalogs/Filters/Filters";
import IFirmNote from "../../interfaces/models/IFirmNote";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const FirmNote: React.FC = () => {
  const fields = [
    'id', 
    'name', 
    'note', 
    'firm',
    'firmName',
    'noteDate', 
    'dateCreated'
  ]
  const endpoint = '/firmNote';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      ),
      enableSorting: false,
    },
    { id: "name", header: "Name" },
    { 
      id: "note", 
      header: "Note", 
      cell: ({ value }: { rowIndex: number; row: any; value: any }) => (
        <p className="line-clamp-3">{value}</p>
      )
    },
    { id: "firm", header: "Firm" },
    { id: "noteDate", header: "Note Date" },
    { id: "createdDate", header: "Created Date" },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg">
            <PencilEdit />
          </div>
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  const formatData = (data: IFirmNote[]) => {
    const formatedData = data.map(d => {
      return {
        ...d,
        firm: d.firmName,
        noteDate: d.dateCreated ? formatDateToString(new Date(d.dateCreated)) : '',
        createdDate: d.dateCreated ? formatDateToString(new Date(d.dateCreated)) : ''
      }
    })
    return formatedData
  }

  const { firmData } = UseFirmList();

  const filtersData: IFilterData[] = React.useMemo(() => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Firm",
        objectData: firmData?.map((f: any) => ({id:f.id, name: f.name})) || [],
      },
    ], [firmData]);

  return (
    <>
        <CatalogTableC
          title={`Firm Note Catalog`}
          catalogName={"FIRM NOTES"}
          catalogShortName="FIRM NOTE"
          route={"firmNote"}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default FirmNote;
